import { render, staticRenderFns } from "./GraphChart.vue?vue&type=template&id=be28c6c6&"
import script from "./GraphChart.vue?vue&type=script&lang=js&"
export * from "./GraphChart.vue?vue&type=script&lang=js&"
import style0 from "./GraphChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports